module.exports = __webpack_public_path__ + "img/kwik-e-mart.d33004e4.png";